import { h } from 'preact';
import BaseComponent from '../BaseComponent';
import { update } from 'Emitter';
import { UI } from 'StateEvents';

export default class Skip extends BaseComponent {
  constructor() {
    super();
  }

  onSkip() {
    update(UI.SKIPPED, 'onSkip');
  }

  render(props) {
    if(props.media.canSkip && props.options.skip) {
      let classes = 'skip clickable';

      if(!props.options.countdown) {
        classes += ' no-countdown';
      }
      return <div class={ classes } onClick={ this.onSkip.bind(this) }>Skip Ad</div>
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/UpperControls/Skip.js